function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    }
    else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
          return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}

function addItemToSessionStorage(customerId, variantId) {
  let storageIds = sessionStorage.getItem(`${customerId}-items`);

  storageIds = storageIds.split(",");
  if (storageIds.includes(variantId)) return;

  storageIds.push(variantId);
  storageIds.join(",");
  sessionStorage.setItem(`${customerId}-items`, storageIds);
}

function removeItemFromSessionStorage(customerId, variantId) {
  let storageIds = sessionStorage.getItem(`${customerId}-items`);

  storageIds = storageIds.split(",");
  var index = storageIds.indexOf(variantId);
  if (index !== -1) {
    storageIds.splice(index, 1);
  }

  storageIds.join(",");
  sessionStorage.setItem(`${customerId}-items`, storageIds);
}

function overridesItemsSessionsStorage(customerId, storageItems) {
  storageItems = storageItems.join(",");
  sessionStorage.setItem(`${customerId}-items`, storageItems);
}

function getItemsFromSessionStorage(customerId) {
  let storageItems = sessionStorage.getItem(`${customerId}-items`);

  if (!storageItems) return [];

  return storageItems.split(",");
}


function isVariantInStorage(customerId, variantId) {
  let storageIds = sessionStorage.getItem(`${customerId}-items`);
  if (!storageIds || storageIds == "") {
    return false;
  }

  storageIds = storageIds.split(",");
  if (storageIds.includes(variantId)) return true;
}


class RegistryClient {

  constructor(customer, signature, timestamp, shop, host) {
    this.customer = customer
    this.config = {
      url: host,
      timestamp,
      signature,
      shop
    }
  }

  request(method, endpoint, body) {
    const { url, timestamp, signature, shop } = this.config
    var callUrl = new URL(url + endpoint);
    callUrl.searchParams.append('shop', shop);
    callUrl.searchParams.append('timestamp', timestamp);
    callUrl.searchParams.append('signature', signature);

    return fetch(callUrl, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
  }

  getCustomerRegistries() {
    return this.request("GET", `/customers/${this.customer.id}/registries`); // will be used in future;
  }

  getCustomerRegistry(registryId, callback) {
    return this.request("GET", `/customers/${this.customer.id}/registries/${registryId}`);
  }

  deleteItemFromRegistry(itemId, body, callback) {
    return this.request("DELETE", `/customers/${this.customer.id}/registry_items/${itemId}`, body);
  }

  cancelRegistry(registryId) {
    return this.request("POST", `/customers/${this.customer.id}/registries/${registryId}/cancel`);
  }

  createRegistry(body) {
    return this.request("POST", `/customers/${this.customer.id}/registries`, body);
  }

  updateRegistry(registryId, body) {
    return this.request("PATCH", `/customers/${this.customer.id}/registries/${registryId}`, body);
  }

  addGiftRegistryItem(body) {
    return this.request("POST", `/customers/${this.customer.id}/registry_items`, body);
  }

  updateGiftRegistryItem(itemId, body) {
    return this.request("PATCH", `/customers/${this.customer.id}/registry_items/${itemId}`, body);
  }

  getGiftTracker(registryId) {
    return this.request("GET", `/customers/${this.customer.id}/registries/${registryId}/gift_tracker`);
  }

  shareRegistry(registryId, body) {
    return this.request("POST", `/customers/${this.customer.id}/registries/${registryId}/share`, body);
  }
}

class RegistryPublicClient {

  constructor(host) {
    this.config = {
      url: host
    }
  }

  request(method, endpoint, body) {
    const { url } = this.config
    var callUrl = new URL(url + endpoint);
    return fetch(callUrl, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
  }

  searchWithName(registrantName) {
    return this.request("GET", `/registries/search?registrant_name=${encodeURIComponent(registrantName)}`);
  }

  getPublicRegistry(registryId, password) {
    password = encodeURI(password);
    return this.request("GET", `/registries/${registryId}?password=${encodeURIComponent(password)}`);
  }
}
